var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBlankTagInCircle = function SvgBlankTagInCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#DFE8F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    stroke: "#004996",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m23.242 30.414 7.172-7.172a2 2 0 0 0 0-2.829L21 11H11v10l9.413 9.415a2 2 0 0 0 2.829-.001z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(9 9)",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgBlankTagInCircle;